import { render, staticRenderFns } from "./SelectedItems.vue?vue&type=template&id=481efa42"
import script from "./SelectedItems.vue?vue&type=script&lang=js"
export * from "./SelectedItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports